(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-collection-action-steps"] && !Shopify.designMode) return;
  try {
    
  const promoStepsHeader = document.querySelector('.promo-steps__header');
  if(promoStepsHeader) {
      promoStepsHeader.addEventListener('click', function() {
        this.closest('.promo-steps').classList.remove('promo-steps--start');
        this.closest('.promo-steps').classList.toggle('promo-steps--open');        
      });    
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-seo-block"] && !Shopify.designMode) return;
  try {
    
  function initSeoReadMore() {
    document.querySelectorAll('.seo-section__body').forEach(function (body) {
      var section = body.closest('.seo-section');
      if (!section) { return; }

      var toggleInput = section.querySelector('.seo-section__toggle-input');

      // Al uitgeklapt? Dan zegt scrollHeight niks over overflow, en weghalen
      // van de checkbox zou de tekst juist weer dichtklappen.
      if (toggleInput && toggleInput.checked) { return; }

      var hasOverflow = body.scrollHeight > body.clientHeight;
      if (hasOverflow) { return; }

      if (toggleInput) { toggleInput.remove(); }

      var readMore = section.querySelector('.seo-section__read-more');
      if (readMore) { readMore.remove(); }
    });
  }

  // Anker binnen de ingeklapte tekst: eerst uitklappen, dan laten scrollen.
  function expandSeoSectionFor(target) {
    if (!target) { return; }

    var body = target.closest('.seo-section__body');
    if (!body) { return; }

    var section = body.closest('.seo-section');
    if (!section) { return; }

    var toggleInput = section.querySelector('.seo-section__toggle-input');
    if (toggleInput) { toggleInput.checked = true; }
  }

  function initSeoToc() {
    document.querySelectorAll('.seo-toc a[href^="#"]').forEach(function (link) {
      if (link.dataset.seoTocBound) { return; }
      link.dataset.seoTocBound = '1';

      link.addEventListener('click', function () {
        expandSeoSectionFor(document.getElementById(link.getAttribute('href').slice(1)));
      });
    });

    if (window.location.hash.length > 1) {
      expandSeoSectionFor(document.getElementById(window.location.hash.slice(1)));
    }
  }

  function initSeoSection() {
    initSeoToc();
    initSeoReadMore();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSeoSection);
  } else {
    initSeoSection();
  }

  document.addEventListener('shopify:section:load', initSeoSection);

  } catch(e) { console.error(e); }
})();
})();
